document.addEventListener('DOMContentLoaded', function () {
  const textarea = document.getElementById('CartDrawer-Note');
  const counter = document.getElementById('note-count');
  if (!textarea && !counter) return;
  const max = textarea.getAttribute('maxlength');

  function updateCount() {
    const current = textarea.value.length;
    counter.textContent = `(${current} / ${max})`;
  }

  textarea.addEventListener('input', updateCount);

  // Initialize on load (for saved cart note)
  updateCount();
});
